import script from "./AccountSummaryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountSummaryTable.vue?vue&type=script&setup=true&lang=js"

import "./AccountSummaryTable.vue?vue&type=style&index=0&id=6a4580f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4580f6"]])

export default __exports__